import React, { Component } from 'react';
import {toJS, observable, autorun} from 'mobx';
import { inject, observer } from 'mobx-react';
import { withRouter, Link } from 'react-router-dom';
import { compose } from 'recompose';
import {withAuthorization} from './utils/auth';
import RequestForm from "./RequestForm";
import {db} from './firebase/firebase';

import { Table, Spin, Input, Button, Tag, Icon, Divider, Modal } from "antd";
import moment from 'moment-timezone';

import { Document, Collection } from 'firestorter';
@observer
class Requests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requests: null,
      selection: [],
      users: {},
      loading: true,
      visible: false
    }
    this.dispose = undefined;
    console.log('requests PROPS', this.props);
    this.doDelete = this.doDelete.bind(this);
    this.getDocs = this.getDocs.bind(this);
    this.getUser = this.getUser.bind(this);
    this.props.userStore.requests.query =  this.props.userStore.requests.ref.orderBy('startTime', 'desc');
    this.createRequest = this.createRequest.bind(this);
    this.requests = this.props.data || new Collection('requests');
  }

  componentDidMount() {
    // db.collection('transactions').where('requestStartTime', '<', "hello").where('processed', '==', false).where('processInstant', '==', false).where('type', '==', 'payin')
    // .where('refund', '==', false)
    // .get().then((res) => {
    //   console.log('ress', res)
    // })
    if(this.props.requests){

      this.setState({ requests: this.getDocs(this.props.requests.docs).filter(d => d) });
      this.setState({ loading: false });

    } else if (this.state.requests == null) {
      this.setState({ loading: true });
      // this.dispose = autorun(() => {
      //   // this.request = this.requestDocument.data;
      //
      //   this.setState({ requests: this.requests.docs });
      //   // console.log("{request}", this.request);
      // });
      console.log('REQUEST == NUL');
      db.collection("requests").get().then((querySnapshot) => {
          console.log("querySnapshot.size", querySnapshot.size);
          const requests = this.getDocs(querySnapshot.docs).filter(d => d);
          this.setState({ requests });
          this.setState({ loading: false });
      });
      // var requests = null;

      // this.setState({ loading: false });
    }
  }
  componentWillUnmount(){
    this.setState(null);
    // this.dispose();
  }


    // async getUser(userId) {
    //   if(!this.UserNames[userId]){
    //     var userDocument = new Document("users/" + userId, {
    //       mode: "off"
    //     });
    //     const user = await userDocument.fetch();
    //     if(user.data) {
    //       var prev = {...this.UserNames};
    //       prev[userId] = user.data;
    //       this.UserNames = prev;
    //       // this.setState({users: prev});
    //     } else {
    //       var prev = {...this.UserNames};
    //       prev[userId] = {
    //         firstname: 'Utilisateur',
    //         lastname: 'Supprimé'
    //       };
    //       this.UserNames = prev;
    //       // this.setState({users: prev});
    //     }
    //
    //   }
    // }
  getDocs(docs) {
    console.log("Get DOCS");
    var userIds = [];
    if(docs) {
       var returnDocs = docs.map((doc, i) => {
        if (doc.id.includes("SUPER")) {
          return;
        }
        doc.data = doc.data();
        if(userIds.indexOf(doc.data.nurse.id) < 0){
          userIds.push(doc.data.nurse.id)
        }

        if(userIds.indexOf(doc.data.author) < 0){
          userIds.push(doc.data.author);
        }
        // this.getUser(doc.data.author);
        // this.getUser(doc.data.nurse.id);
        return ({
            key: i,
            duration: doc.data.duration,
            nurse: {
              id: doc.data.nurse.id
            },
            author: {
              id: doc.data.author
            },
            rate: doc.data.rate,
            tasks: doc.data.tasks,
            startTime: doc.data.startTime,
            refund: doc.data.refund,
            payment: doc.data.payment,
            isCancelled: doc.data.isCancelled,
            id: doc.id,
            doc: doc
          });
      });

      console.log("userIds: ", userIds);
      userIds.map( async (userId) => {
        return await this.getUser(userId);
      });
      return returnDocs;
    } else {
      return null
    }

    // this.setState({requests: docs});
    // return docs;
  }
  selector = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      this.setState({selection: selectedRows});
    },
    // getCheckboxProps: record => ({ // Disable checkbox on ADMIN USER
    //   disabled: record.role === 'admin'
    // }),
  }
  async createRequest(data) {
    this.setState({loading: true});
    const doc = await this.props.userStore.requests.add(data);

    this.setState({loading: false});
  }
  doDelete(){
    this.setState({loading: true});
    this.state.selection.map(async (data) => {
      await data.doc.delete();
    })
    this.setState({loading: false});
  }
  renderTag = (value) => {
    var results = [];

    value.map((tag, i) => {
      results.push(<Tag key={i} color="purple">{tag}</Tag>);
    })
    return results
  }
  getUserPromise(userId) {
    return new Promise((resolve, reject) => {

    })
  }
  getUser(userId) {
    return new Promise(async (resolve, reject) => {
      if(!this.state.users[userId]){
        var userDocument = new Document("users/" + userId, {
          mode: "off"
        });
        const user = await userDocument.fetch();
        if(user.data) {
          var prev = {...this.state.users};
          prev[userId] = user.data;
          this.setState({users: prev});
        } else {
          var prev = {...this.state.users};
          prev[userId] = {
            firstname: 'Utilisateur',
            lastname: 'Supprimé'
          };
          this.setState({users: prev});
        }
      }
      resolve();
    });
  }

  doAltStringSort(a, b){
    if(!a && !b){
      return 0;
    }
    if(!a && b){
      return -1;
    }
    if(a && !b){
      return 1;
    }
  }
  doStringSort(a, b){
    if(a === undefined && b === undefined || b === null && a === null || !a && !b){
      return 0;
    }
    if(a === undefined || a === null || !a){
      return -1;
    }
    if(b === undefined || b === null || !b){
      return -1;
    }

    return a.localeCompare(b);
  }
  doDateSort(a, b){
    if(a === undefined && b === undefined || b === null && a === null){
      return 0;
    }
    if(a === undefined || a === null){
      return -1;
    }
    if(b === undefined || b === null){
      return -1;
    }
    if(moment(a).isBefore(moment(b))){
      return -1;
    }
    if(moment(a).isAfter(moment(b))){
      return 1;
    }
    return 0;
  }

  sortByName(idA, idB) {
    
    const personA = this.state.users[idA];
    const personB = this.state.users[idB];
    if (!personA || !personB)
      return 0;
    return this.doStringSort(
      personA.firstname + personA.lastname,
      personB.firstname + personB.lastname
    );
  }

  render() {
    return (
      <div>
        {this.props.onlyTable ? null :
          <div>
            <Modal
            title="Nouvelle Demande"
            style={{ top: 20}}
            width={900}
            visible={this.state.visible}
            onCancel={() => this.setState({ visible: false })}
            footer={null}
          >

            <RequestForm submit={this.createRequest} closeModal={() =>this.setState({visible :false})}/>
          </Modal>
          <h1>Prestations</h1>
            <Button
              style={{ margin: 5 }}
              type="primary"
              onClick={() => this.setState({ visible: true })}
              icon="plus"
              loading={
                this.state.loading || this.props.userStore.requests.fetching
              }
            >
              Nouveau
            </Button>
          </div>
        }
          <br/>
          <Spin spinning={this.state.loading || toJS(this.props.userStore.requests.fetching)} indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}>
          <Table
            dataSource={this.state.requests}
            columns={[
              {title: <Icon type="star-o" />, dataIndex: "rate", key: "rate", width: "5%", sorter: (a,b) => a.rate ? 1 : -1, render: value => value ? <Icon type="check-square"/> : <Icon type="close-square-o"/> },
              { title: "Client", dataIndex: "author", key: "author", width: '20%', sorter: (a, b) => this.sortByName(a.author.id, b.author.id), render: value => {
                if(this.state.users[value.id]){
                  return (<Link to={'/users/'+value.id}>{this.state.users[value.id].firstname} {this.state.users[value.id].lastname}</Link>)
                } else {
                  return (<a>Chargement...</a>)
                }
              }},
              { title: "Intervenant", dataIndex: "nurse", key: "nurse", width: '20%', sorter: (a, b) => this.sortByName(a.nurse.id, b.nurse.id), render: (value) => {
                if(this.state.users[value.id]){
                  return (<Link to={'/users/'+value.id}>{this.state.users[value.id].firstname} {this.state.users[value.id].lastname}</Link>)
                } else {
                  return (<a>Chargement...</a>)
                }
              } },
              { title: "Payée?", dataIndex: "payment", key: "payment", width: '12%', sorter: (a,b) => this.doStringSort(a.payment, b.payment), render: value => value && value !== 'cancelled' ? value : 'non' },
              { title: "Annulée?", dataIndex: "isCancelled", width: '12%', key: "isCancelled", sorter: (a,b) => this.doAltStringSort(a.isCancelled, b.isCancelled), render: value => value ? <Icon type="check-square"/> : <Icon type="close-square-o"/> },
              { title: "Remboursée?", dataIndex: "refund", key: "refund", width: '12%', sorter: (a,b) => a.refund && b.refund ? a.refund - b.refund : a.refund ? 1 : -1, render: (value, record) => <span>{record.refund}</span> },
              { title: "Date de début", dataIndex: "startTime", key: "startTime", defaultSortOrder: "ascend", width: '15%', sorter: (a,b) => this.doDateSort(a.startTime, b.startTime), render: value => <span style={{whiteSpace: "nowrap"}}>{moment(value).format('DD-MM-YYYY HH[h]mm')}</span> },
              { title: "Durée", dataIndex: "duration", key: "duration", width: '10%', render: value => value + 'H' },
              // { title: "Tâches", dataIndex: "tasks", width: '10%', render: this.renderTag, key: "tasks", filters: [
              //   {text: 'Ménage', value: 'Ménage'},
              //   {text: 'Courses', value: 'Courses'},
              //   {text: 'Entretien du linge', value: 'Entretien du linge'},
              //   {text: 'Promenade', value: 'Promenade'},
              //   {text: 'Repas', value: 'Repas'},
              //   {text: 'Aide à la toilette', value: 'Aide à la toilette'},
              //   {text: 'Aide au lever', value: 'Aide au lever'},
              //   {text: 'Aide au coucher', value: 'Aide au coucher'},
              //   {text: 'Compagnie de jour', value: 'Compagnie de jour'},
              //   {text: 'Compagnie de nuit', value: 'Compagnie de nuit'}
              // ], onFilter: (val, record) => {return record.tasks ? (record.tasks.indexOf(val) === 0) : false } },
              { title: 'Action', render: (value, item) => {
                return (
                <Button
                  style={{ margin: 5 }}
                  type="primary"
                  href={'/requests/'+item.id}
                >Voir</Button>
              )}}
            ]} />
          </Spin>
      </div>
    )
  }
}

const authCondition = (authUser) => !!authUser;

const hasProps = injectedProps => WrappedComponent => {
  const HasProps = props => <WrappedComponent {...injectedProps} {...props} />

  return HasProps
}
export const RequestsTable = compose(withAuthorization(authCondition),
  inject('userStore'), observer)(Requests);
export default compose(
  withAuthorization(authCondition),
  inject('userStore'),
  withRouter,
  observer
)(Requests);



// WEBPACK FOOTER //
// ./src/Requests.js